export default __webpack_public_path__ + "d61111fcbfda85ad7aefd70f60e7963f.jpg";